<div class="row">
	<div class="row">
		<button
			(click)="backToExistingConv()"
			class="btn col-2 back justify-content-center text-center hand-cursor theme-violet-color"
		>
			<i class="pink-btn fs-3 bi bi-arrow-left" aria-hidden="true"></i>
		</button>
		<label class="col-8 title form-label theme-main-color fs-4 text-center">
			Nouvelle conversation
		</label>
	</div>
	<input
		type="text"
		class="form-control"
		placeholder="Recherche"
		[(ngModel)]="searchedName"
	/>
</div>
<div id="scroll" class="row py-4 scroll">
	<div
		*ngFor="
			let userOfList of filteredUsers | filterUsersByEmployeeName: searchedName
		"
		profile="button"
		(click)="emitReceiver(userOfList)"
	>
		<div
			*ngIf="userOfList.id !== user.id"
			class="d-flex justify-content-center border-bottom ps-2 py-3 hoverEmployee"
			[ngClass]="{
				'theme-blue-background-color text-white': secondPersonId === userOfList
			}"
		>
			<div>
				<span class="me-2">{{ userOfList.firstName }}</span>
				<span class="me-2">{{ userOfList.lastName }}</span>
				<span
					class="text-white notification rounded-circle theme-green-background-color text-center"
					*ngIf="getNotificationNumberByIdSender(userOfList.id) > 0"
				>
					{{ getNotificationNumberByIdSender(userOfList.id) }}
				</span>
			</div>
		</div>
	</div>
</div>
